import React from 'react';

import { ICellRendererParams } from 'ag-grid-community';
import { Link } from 'react-router-dom';
import { EXCEL_DATE_STYLE_ID, LINK_COLOR } from 'src/constants/agGrid';
import { ROUTES } from 'src/constants/routes';
import { emptyCellFormatter } from 'src/util/grid/cellFormatter';
import {
    getStatusFromStartEndDates,
    getYYYYMMDDStrFromTimestamp,
    getYYYYMMDDUTCStrFromTimestamp
} from 'src/util/grid/cellGetter';
import { getStatusCellRenderer } from 'src/util/grid/cellRenderer';
import { dateFilterOptions } from 'src/util/grid/filter';
import { dateComparator, dateFilterComparator } from 'src/util/grid/sort';

export const dealsColDefs = [
    {
        field: 'serviceName',
        headerName: 'Service',
        filter: 'agSetColumnFilter'
    },
    {
        field: 'contractName',
        headerName: 'Rate card',
        filter: 'agSetColumnFilter',
        cellRenderer: (params: ICellRendererParams) => {
            return (
                <Link
                    style={{ color: LINK_COLOR, textDecoration: 'none' }}
                    to={`${ROUTES.RATE_CARDS.INDEX}/${params.data.contractId}`}
                >
                    {params.value}
                </Link>
            );
        },
        width: 400
    },
    {
        field: 'startDate',
        headerName: 'Start date',
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: {
            filterOptions: dateFilterOptions,
            defaultOption: 'greaterThanOrEqual',
            comparator: dateFilterComparator,
            includeBlanksInLessThan: true,
            includeBlanksInGreaterThan: true
        },
        cellClass: EXCEL_DATE_STYLE_ID,
        valueGetter: getYYYYMMDDUTCStrFromTimestamp
    },
    {
        field: 'endDate',
        headerName: 'End date',
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: {
            filterOptions: dateFilterOptions,
            defaultOption: 'lessThanOrEqual',
            comparator: dateFilterComparator,
            includeBlanksInLessThan: true,
            includeBlanksInGreaterThan: true
        },
        cellClass: EXCEL_DATE_STYLE_ID,
        valueFormatter: emptyCellFormatter,
        valueGetter: getYYYYMMDDUTCStrFromTimestamp
    },
    {
        field: 'creationDate',
        headerName: 'Last updated',
        comparator: dateComparator,
        filter: 'agDateColumnFilter',
        filterParams: {
            filterOptions: dateFilterOptions,
            defaultOption: 'greaterThanOrEqual',
            comparator: dateFilterComparator,
            includeBlanksInLessThan: true,
            includeBlanksInGreaterThan: true
        },
        cellClass: EXCEL_DATE_STYLE_ID,
        valueGetter: getYYYYMMDDStrFromTimestamp
    },
    {
        field: 'status',
        headerName: 'Status',
        valueGetter: getStatusFromStartEndDates,
        cellRenderer: getStatusCellRenderer,
        cellRendererParams: {
            displayText: true
        }
    }
];
